import React from "react";

// Style
import * as S from "./style";

import logoLinkedin from "../../assets/linkedin-icon.svg";

export interface SocialProps {
  id: string;
  title: string;
  subjects?: string[];
  parent?: {
    title: string;
  };
  category?: string;
}

const Social: React.FC<SocialProps> = ({
  subjects,
  title,
  id,
  parent,
  category,
}) => {
  const hashtags =
    subjects &&
    subjects.map((sub) => {
      sub = sub.replace("-", "");
      return sub;
    });

  const contentUrl = `https://www.unitiva.it/${
    category ? category : parent && parent.title.toLowerCase().replace(" ", "-")
  }/${id.split("/").pop()}`;

  const shareText = `${title}\n${contentUrl}\n${
    hashtags ? `#${hashtags.join(" #")}` : ""
  }`;

  return (
    <S.Social>
      <div className="share">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${contentUrl}`}
          target="__blank"
        >
          <i className="facebook">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect width="30" height="30" fill="none" />
                </clipPath>
              </defs>
              <g id="facebook" >
                <path
                  id="facebook"
                  aria-label="Logo Facebook"
                  d="M20,10.1C20,4.5,15.5,0,10,0S0,4.5,0,10.1c0,5,3.7,9.2,8.4,9.9v-7H5.9v-2.9h2.5V7.8
                                    c0-2.5,1.5-3.9,3.8-3.9c1.1,0,2.2,0.2,2.2,0.2v2.5h-1.3c-1.2,0-1.6,0.8-1.6,1.6v1.9h2.8L13.9,13h-2.3v7
                                    C16.3,19.2,20,15.1,20,10.1"
                />
              </g>
            </svg>
          </i>
        </a>
        <a
          href={`https://www.linkedin.com/feed/?shareActive=true&url=${`https://www.unitiva.it/${contentUrl}`}&text=${encodeURIComponent(
            shareText
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="linkedin">
            <img src={logoLinkedin} alt="logo Linkedin" />
          </i>
        </a>
      </div>
    </S.Social>
  );
};

export default Social;
